import type { SiteConfig } from '@/types'
import { getOrigin } from '@/lib/window'

export const siteConfig: SiteConfig = {
    name: 'Metric Berlin 2026',
    description: 'Three days on how teams measure what matters, and decide what to do about it. May 11-13, Station Berlin.',
    placeholder: 'Your new site will appear right here. Just ask Modulify to generate anything you can describe.',
    url: getOrigin(),
    ogImage: '/images/hero.png'
}
